export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      serviceInfo: [
        {
          serviceId: 4,
          serviceUuid: "services004",
          serviceName: "△△地域サポート",
          communityName: "アイラ地域サポートコミュニティ",
          tenantName: "アイラ株式会社",
          serviceStatus: 1,
          createdAt: 1234567890123
        },
        {
          serviceId: 3,
          serviceUuid: "services003",
          serviceName: "☓☓地域サポート",
          communityName: "アイラ地域サポートコミュニティ",
          tenantName: "アイラ株式会社",
          serviceStatus: 1,
          createdAt: 1234567890123
        },
        {
          serviceId: 2,
          serviceUuid: "services002",
          serviceName: "〇〇地域サポート",
          communityName: "アイラ地域サポートコミュニティ",
          tenantName: "アイラ株式会社",
          serviceStatus: 1,
          createdAt: 1234567890123
        },
        {
          serviceId: 1,
          serviceUuid: "services001",
          serviceName: "アイラ地域サポート",
          communityName: "アイラ地域サポートコミュニティ",
          tenantName: "アイラ株式会社",
          serviceStatus: 1,
          createdAt: 1234567890123
        }
      ]
    }
  }
}